import { render } from "./DobDialog.vue?vue&type=template&id=df51683e&scoped=true"
import script from "./DobDialog.vue?vue&type=script&lang=js"
export * from "./DobDialog.vue?vue&type=script&lang=js"

import "./DobDialog.vue?vue&type=style&index=0&id=df51683e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df51683e"]])

export default __exports__